export default "__VITE_ASSET__Y3FR0PrC__"